// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__uD7Al","before_dashed":"Sidebar_before_dashed__SMuz4"};